const trimToMaxLength = (value, maxLength) => value.trimStart().substring(0, maxLength);

export default trimToMaxLength;
